import { Radio, RadioGroup } from '@mantine/core'
import type { FC } from 'react'

type CustomRadioGroupProps = {
  name: string
  title: string
  description: string | null
  options: string[]
  error: string | undefined
}

export const CustomRadioGroup: FC<CustomRadioGroupProps> = ({
  name,
  title,
  description,
  options,
  error,
}) => {
  return (
    <RadioGroup
      name={name}
      label={title}
      description={description}
      defaultValue={options[0]}
      error={error}
    >
      {options.map((option, idx) => (
        <Radio
          value={option}
          key={`${option}-${idx + 1}`}
          label={option}
          my='md'
        />
      ))}
    </RadioGroup>
  )
}
